import { getRequest, postRequest } from "../../app/axiosClient";
import { getRoleAccessRecords } from "../RoleManagement/RoleManagementSlice";
import OpenNotificationWithIcon from "../../components/VibrantSolComponents/Notification";
import {
  showLoader,
  hideLoader,
} from "../../components/VibrantSolComponents/GlobalSpinnerSlice";
import { message } from "antd";
export const getRoleAccessRecordsApi = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/RoleManagement/GetAllUserRoleAccess`)
      .then((res) => {
        if (res?.data) {
          dispatch(getRoleAccessRecords(res.data));
        }
        dispatch(hideLoader());
        // message.success("Role access records fetched successfully.");
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Error",
          "Unable to get the role access records. Please try again."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Error",
      "Unable to get the role access records. Please try again."
    );
  }
};
export const updateRoleAccessRecordsApi = (values, callback) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/RoleManagement/UpdateUserRoleAccess`, values)
      .then((res) => {
        dispatch(getRoleAccessRecordsApi(res?.data));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Success",
          "Role access records updated successfully."
        );
        if (callback) callback(true, res?.data);
      })
      .catch((e) => {
        dispatch(hideLoader());
        if (callback) callback(false, null);

        OpenNotificationWithIcon(
          "error",
          "Error",
          "Unable to update the role access records. Please try again."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    if (callback) callback(false, null);

    OpenNotificationWithIcon(
      "error",
      "Error",
      "Unable to update the role access records. Please try again."
    );
  }
};
